import axios from '@/utils/axios'
import {platform, platformUserPrefix} from '../../common'

/**
 * 获取租户信息
 * @param nameCode
 * @param NotNeedErrorMessage
 */
export const getTenantInfo = (nameCode, NotNeedErrorMessage = false) => {
  return axios({
    url: `${platform}/platform/tenant/tenantInfo`,
    headers: {
      ...(NotNeedErrorMessage ? {'NotNeedErrorMessage': true} : {}),
      NotNeedAuthorization: true
    },
    method: 'get',
    params: {nameCode}
  })
}

/**
 * 根据租户域名获取租户名称编码
 * @param domainName
 * @param NotNeedErrorMessage
 */
export const getTenantNameCode = (domainName, NotNeedErrorMessage = false) => {
  return axios({
    url: `${platform}/platform/tenant/tenantNameCode`,
    headers: {
      ...(NotNeedErrorMessage ? {'NotNeedErrorMessage': true} : {})
    },
    method: 'get',
    params: {domainName}
  })
}

/**
 * 平台租户信息列表
 * @param pageInfo 分页信息和查询条件
 * @param params 筛选条件
 * @returns {*}
 */
export const platformTenantTable = (pageInfo, params) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/platformTenantTable`,
    method: 'post',
    data: pageInfo,
    params: params
  })
}

/**
 * 获取租户完整信息
 * @param tenantCode
 */
export const getFullTenantInfo = (tenantCode) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/getFullTenantInfo`,
    method: 'get',
    params: {tenantCode}
  })
}

/**
 * 租户配置界面获取租户基本信息
 * @returns {*}
 */
export const getTenantBaseInfo = (data) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/getTenantBaseInfo`,
    method: 'post',
    data: data
  })
}

/**
 * 添加平台租户
 * @param form
 */
export const addPlatformTenant = form => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/addPlatformTenant`,
    method: 'post',
    data: form
  })
}

/**
 * 修改平台租户
 * @param form
 */
export const editPlatformTenant = form => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/editPlatformTenant`,
    method: 'post',
    data: form
  })
}

/**
 * 删除租户信息
 * @param tenantCodes 租户编号串
 */
export const removePlatformTenant = (tenantCodes) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/removePlatformTenant`,
    method: 'delete',
    params: {tenantCodes}
  })
}

/**
 * 获取租户短信配置
 * @param tenantCode
 */
export const getTenantSmsConfig = (tenantCode) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/getTenantSmsConfig`,
    method: 'get',
    params: {tenantCode}
  })
}

/**
 * 修改租户短信配置
 * @param form
 */
export const editTenantSmsConfig = form => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/editTenantSmsConfig`,
    method: 'post',
    data: form
  })
}

/**
 * 获取租户接口配置
 * @param tenantCode
 */
export const getTenantApiConfig = (tenantCode) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/getTenantApiConfig`,
    method: 'get',
    params: {tenantCode}
  })
}

/**
 * 修改租户接口配置
 * @param form
 */
export const editTenantApiConfig = form => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/editTenantApiConfig`,
    method: 'post',
    data: form
  })
}

/**
 * 平台租户信息列表
 * @param params
 */
export const platformTenantList = () => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/list`,
    method: 'get'
  })
}

/**
 * 生成 AES KEY
 */
export const generateKey = () => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/generateKey`,
    method: 'get'
  })
}

/**
 * 获取租户支付配置
 * @param idCode
 */
export const getTenantPayConfDetail = (idCode) => {
  return axios({
    url: `${platform}${platformUserPrefix}/wechatPay/detail`,
    method: 'get',
    params: {idCode}
  })
}

/**
 * 修订租户支付配置
 * @param form
 */
export const modifyTenantPayConf = form => {
  return axios({
    url: `${platform}${platformUserPrefix}/wechatPay/modify`,
    method: 'post',
    data: form
  })
}

/**
 * 保存租户诊断配置
 * @param config
 * @returns {*}
 */
export const updateTenantDiagnosisConfig = (config) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/tenantDiagnosisConfig`,
    method: 'post',
    data: config
  })
}

/**
 * 保存租户页面配置
 * @param config
 * @returns {*}
 */
export const updateTenantPageConfig = (config) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/tenantPageConfig`,
    method: 'post',
    data: config
  })
}

/**
 * 获取租户对接配置状态
 * @param tenantCode
 * @returns {*}
 */
export const getTenantApiConfigState = (tenantCode) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/tenantApiConfigState`,
    method: 'get',
    params: {tenantCode}
  })
}

/**
 * 获取租户Logo配置
 * @param tenantCode
 * @returns {*}
 */
export const getTenantLogoConfig = (tenantCode) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/tenantLogoConfig`,
    method: 'get',
    params: {tenantCode}
  })
}

/**
 * 保存租户Logo配置
 * @param form
 * @returns {*}
 */
export const saveTenantLogoConfig = (form) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/tenantLogoConfig`,
    method: 'post',
    data: form
  })
}

/**
 * 获取租户限制参数信息
 * @param tenantCode
 * @returns {*}
 */
export const getTenantLimitParams = (tenantCode) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/tenantLimitParams`,
    method: 'get',
    params: {tenantCode}
  })
}

/**
 * 保存租户限制参数信息
 * @param form
 * @returns {*}
 */
export const saveTenantLimitParams = (form) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/tenantLimitParams`,
    method: 'post',
    data: form
  })
}

/**
 * 获取租户诊断配置
 * @param tenantCode
 * @returns {*}
 */
export const getTenantDiagnosisConfig = (tenantCode) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/tenantDiagnosisConfig`,
    method: 'get',
    params: {tenantCode}
  })
}

/**
 * 获取租户使用方式信息
 * @param tenantCode
 * @returns {*}
 */
export const getTenantUseModeConfig = (tenantCode) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/tenantUseModeConfig`,
    method: 'get',
    params: {tenantCode}
  })
}

/**
 * 保存租户使用方式配置
 * @param form
 * @returns {*}
 */
export const saveTenantUseModeConfig = (form) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/tenantUseModeConfig`,
    method: 'post',
    data: form
  })
}

/**
 * 获取租户管理员列表
 * @param pageInfo
 * @returns {*}
 */
export const getTenantAdmin = (pageInfo) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/tenantAdmin`,
    method: 'post',
    data: pageInfo
  })
}

/**
 * 编辑租户页面显示信息
 * @param tenantCode
 * @returns {*}
 */
export const getPlatformTenantInfo = (tenantCode) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/platformTenantInfo`,
    method: 'get',
    params: {tenantCode}
  })
}

/**
 * 保存编辑租户
 * @param form
 * @returns {*}
 */
export const savePlatformTenantInfo = (form) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/platformTenantInfo`,
    method: 'post',
    data: form
  })
}

/**
 * 获取租户日志
 * @param pageInfo
 * @returns {*}
 */
export const getPlatformTenantLog = (pageInfo) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/platformTenantLog`,
    method: 'post',
    data: pageInfo
  })
}

/**
 * 获取租户诊所列表
 * @param pageInfo
 * @returns {*}
 */
export const getTenantClinic = (pageInfo) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/platformTenantClinic`,
    method: 'post',
    data: pageInfo
  })
}

/**
 * 获取租户医生列表
 * @param pageInfo
 * @returns {*}
 */
export const getTenantDoctor = (pageInfo) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/platformTenantDoctor`,
    method: 'post',
    data: pageInfo
  })
}

/**
 * 保存租户自有药材库模式配置
 * @param form
 * @returns {*}
 */
export const saveTenantStockConfig = (form) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/tenantStockConfig`,
    method: 'post',
    data: form
  })
}

/**
 * 保存租户其他配置
 * @param form
 * @returns {*}
 */
export const saveExtraInfo = (form) => {
  return axios({
    url: `${platform}${platformUserPrefix}/platform/tenant/saveExtraInfo`,
    method: 'post',
    data: form
  })
}



// WEBPACK FOOTER //
// ./src/api/platform/tenant/index.js